// ============================================================================
// CHAPITRE 7 : LETTRES ET APOCALYPSE - Niveaux 79 à 91 COMPLET
// ============================================================================

export const chapter7FinalLetters = {
  id: 7,
  name: "Lettres et Apocalypse",
  description: "Celui qui vaincra héritera ces choses... La sagesse d'en haut sanctifie l'intelligence",
  icon: "📜",
  levelRange: { start: 79, end: 91 },
  
  // Sagesse spirituelle : La sagesse divine sanctifie
  spiritualWisdom: {
    principle: "La sagesse d'en haut sanctifie l'intelligence et vivifie l'esprit",
    scripture: "Si quelqu'un manque de sagesse, qu'il la demande à Dieu (Jacques 1:5)",
    application: "Chaque lettre apostolique et chaque vision d'Apocalypse enrichit notre compréhension et fortifie notre espérance"
  },
  
  levels: {
    79: {
      name: "Arrestation à Jérusalem",
      challenge: "Je suis prêt non seulement à être lié, mais encore à mourir à Jérusalem...",
      questions: {
        easy: {
          question: "Où Paul fut-il arrêté lors de sa dernière visite ?",
          options: ["Antioche", "Éphèse", "Jérusalem", "Corinthe"],
          correct: 2,
          hint: "La ville sainte qui persécutait souvent les prophètes",
          funFact: "🏛️ Jérusalem : lieu de gloire et de souffrance pour tous les serviteurs de Dieu!"
        },
        medium: {
          question: "De quoi Paul était-il accusé par les Juifs ?",
          options: [
            "Vol dans le Temple",
            "Profanation du Temple en y introduisant des païens",
            "Blasphème contre Moïse",
            "Rébellion contre Rome"
          ],
          correct: 1,
          hint: "Accusation liée à l'universalité de l'Évangile",
          funFact: "⛪ Ironie : Paul accusé de souiller le Temple qu'il honorait profondément!"
        },
        hard: {
          question: "Comment Paul transforma-t-il sa captivité en opportunité ?",
          options: [
            "Il s'évada",
            "Il témoigna devant les autorités et écrivit ses épîtres",
            "Il se tut",
            "Il négocia sa libération"
          ],
          correct: 1,
          hint: "Il s'agit de transformer l'épreuve en témoignage",
          funFact: "⛓️ Chaînes physiques, liberté spirituelle - témoignage puissant de foi!"
        }
      }
    },
    
    80: {
      name: "Devant le Gouverneur Félix",
      challenge: "Comme il discourait sur la justice, la tempérance et le jugement à venir...",
      questions: {
        easy: {
          question: "Devant quel gouverneur Paul témoigna-t-il de sa foi ?",
          options: ["Pilate", "Félix", "Festus", "Gallio"],
          correct: 1,
          hint: "Gouverneur connu pour sa cupidité",
          funFact: "⚖️ Félix espérait un pot-de-vin - corruption face à l'intégrité!"
        },
        medium: {
          question: "Quelle fut la réaction de Félix au message de Paul ?",
          options: [
            "Il se convertit",
            "Il trembla de peur",
            "Il se moqua",
            "Il resta indifférent"
          ],
          correct: 1,
          hint: "La conscience troublée par la vérité",
          funFact: "😰 Même les corrompus tremblent devant la vérité divine - conscience universelle!"
        },
        hard: {
          question: "Pourquoi Félix garda-t-il Paul prisonnier deux ans ?",
          options: [
            "Pour le protéger",
            "Par intérêt politique et espoir de corruption",
            "Par oubli",
            "Par conviction"
          ],
          correct: 1,
          hint: "Il s'agit de calcul politique et personnel",
          funFact: "🏛️ Justice humaine corrompue vs justice divine parfaite - contraste saisissant!"
        }
      }
    },

    81: {
      name: "Appel à César",
      challenge: "J'en appelle à César !",
      questions: {
        easy: {
          question: "Quel droit Paul invoqua-t-il pour éviter un procès à Jérusalem ?",
          options: [
            "Droit d'asile",
            "Appel à César (citoyen romain)",
            "Droit de fuite",
            "Protection diplomatique"
          ],
          correct: 1,
          hint: "Privilège de sa citoyenneté romaine",
          funFact: "🏛️ Citoyenneté romaine : passeport divin pour porter l'Évangile à Rome!"
        },
        medium: {
          question: "Devant qui Paul témoigna-t-il avant son départ ?",
          options: [
            "Le sanhédrin",
            "Le roi Agrippa et Bérénice",
            "Les soldats romains",
            "La foule juive"
          ],
          correct: 1,
          hint: "Royauté hérodienne judaïsée",
          funFact: "👑 Du berger de troupeaux au palais royal - élévation divine de Paul!"
        },
        hard: {
          question: "Comment Dieu utilise-t-il les systèmes humains pour ses plans ?",
          options: [
            "Il les ignore",
            "Il les utilise providentiellement pour accomplir ses desseins",
            "Il les détruit",
            "Il s'y oppose toujours"
          ],
          correct: 1,
          hint: "Il s'agit de la souveraineté divine sur l'histoire",
          funFact: "🌐 Justice romaine devient véhicule de l'Évangile - providence remarquable!"
        }
      }
    },

    82: {
      name: "Naufrage à Malte",
      challenge: "N'aie point de crainte, Paul ; il faut que tu comparaisses devant César...",
      questions: {
        easy: {
          question: "Sur quelle île Paul fit-il naufrage ?",
          options: ["Crète", "Chypre", "Malte", "Sicile"],
          correct: 2,
          hint: "Petite île au sud de la Sicile",
          funFact: "🏝️ Malte : escale forcée qui devient mission fructueuse - détours divins!"
        },
        medium: {
          question: "Quel miracle Paul accomplit-il à Malte ?",
          options: [
            "Il calma la tempête",
            "Il guérit le père de Publius et d'autres malades",
            "Il multiplia la nourriture",
            "Il ressuscita un mort"
          ],
          correct: 1,
          hint: "Guérisons multiples sur l'île",
          funFact: "🏥 Paul : naufragé devenu médecin miraculeux - réputation divine!"
        },
        hard: {
          question: "Comment ce naufrage illustre-t-il la fidélité divine ?",
          options: [
            "Les accidents arrivent",
            "Dieu protège et accomplit ses promesses malgré les obstacles",
            "Paul avait de la chance",
            "C'était évitable"
          ],
          correct: 1,
          hint: "Il s'agit de la fidélité divine aux promesses",
          funFact: "⛈️ Tempête, naufrage, serpent : rien n'arrête le plan divin pour Paul!"
        }
      }
    },

    83: {
      name: "Paul à Rome",
      challenge: "Il demeura deux années entières dans une maison qu'il avait louée...",
      questions: {
        easy: {
          question: "Dans quelles conditions Paul vécut-il à Rome ?",
          options: [
            "En prison fermée",
            "En résidence surveillée",
            "En liberté totale",
            "En exil"
          ],
          correct: 1,
          hint: "Liberté relative sous surveillance",
          funFact: "🏠 Maison-prison devenue centre missionnaire - liberté dans les chaînes!"
        },
        medium: {
          question: "Que fit Paul pendant ses deux ans à Rome ?",
          options: [
            "Il se reposa",
            "Il enseignait et écrivait ses épîtres",
            "Il préparait sa défense",
            "Il faisait du tourisme"
          ],
          correct: 1,
          hint: "Ministère intense malgré les chaînes",
          funFact: "✍️ Épîtres de la captivité : Éphésiens, Philippiens, Colossiens, Philémon!"
        },
        hard: {
          question: "Comment Paul termina-t-il son ministère selon la tradition ?",
          options: [
            "Il mourut de maladie",
            "Il fut décapité sous Néron vers 67 ap. J.-C.",
            "Il mourut de vieillesse",
            "Il disparut mystérieusement"
          ],
          correct: 1,
          hint: "Martyre sous l'empereur fou",
          funFact: "⚔️ 'J'ai combattu le bon combat, j'ai achevé la course' - victoire finale!"
        }
      }
    },

    84: {
      name: "L'Épître aux Romains",
      challenge: "Je n'ai point honte de l'Évangile : c'est une puissance de Dieu pour le salut...",
      questions: {
        easy: {
          question: "Quelle épître développe le plus la doctrine du salut par la foi ?",
          options: ["1 Corinthiens", "Galates", "Romains", "Éphésiens"],
          correct: 2,
          hint: "La 'cathédrale' théologique de Paul",
          funFact: "🏛️ Romains : chef-d'œuvre théologique qui a converti Augustin et Luther!"
        },
        medium: {
          question: "Selon Romains, comment l'homme est-il justifié devant Dieu ?",
          options: [
            "Par ses bonnes œuvres",
            "Par la foi seule, sans les œuvres",
            "Par les sacrifices",
            "Par la tradition"
          ],
          correct: 1,
          hint: "Principe fondamental de la Réforme",
          funFact: "⚖️ 'Le juste vivra par la foi' - révolution spirituelle de Paul!"
        },
        hard: {
          question: "Quelle est la portée universelle de cette épître ?",
          options: [
            "Elle ne concerne que les Romains",
            "Elle expose le plan de salut pour toute l'humanité",
            "Elle critique seulement Rome",
            "Elle est obsolète"
          ],
          correct: 1,
          hint: "Il s'agit du plan universel de salut",
          funFact: "🌍 Évangile = puissance de Dieu pour tous : Juifs et Grecs - universalité totale!"
        }
      }
    },

    85: {
      name: "L'Hymne de l'Amour - 1 Corinthiens 13",
      challenge: "Quand je parlerais les langues des hommes et des anges, si je n'ai pas l'amour...",
      questions: {
        easy: {
          question: "Quel chapitre de la Bible est appelé 'l'hymne à l'amour' ?",
          options: [
            "1 Corinthiens 12",
            "1 Corinthiens 13",
            "1 Jean 4",
            "Romains 8"
          ],
          correct: 1,
          hint: "Le chapitre central de 1 Corinthiens",
          funFact: "💝 Chapitre le plus lu aux mariages - définition parfaite de l'amour!"
        },
        medium: {
          question: "Que dit Paul sur la durée de l'amour ?",
          options: [
            "L'amour passe avec le temps",
            "L'amour ne périt jamais",
            "L'amour dépend des circonstances",
            "L'amour est temporaire"
          ],
          correct: 1,
          hint: "Éternité de l'amour divin",
          funFact: "♾️ Seul l'amour traverse la mort et l'éternité - valeur suprême!"
        },
        hard: {
          question: "Pourquoi Paul place-t-il l'amour au-dessus des dons spirituels ?",
          options: [
            "Les dons sont mauvais",
            "L'amour donne sens et valeur à tout le reste",
            "L'amour est plus facile",
            "Les dons divisent"
          ],
          correct: 1,
          hint: "Il s'agit du moteur et du sens de tout service",
          funFact: "🎯 Sans amour, même les plus grands dons deviennent bruit et orgueil!"
        }
      }
    },

    86: {
      name: "Éphésiens : L'Église Corps du Christ",
      challenge: "Il a tout mis sous ses pieds, et il l'a donné pour chef suprême à l'Église...",
      questions: {
        easy: {
          question: "Selon Éphésiens, qu'est-ce que l'Église dans sa relation au Christ ?",
          options: [
            "Son temple",
            "Son corps",
            "Sa famille",
            "Son armée"
          ],
          correct: 1,
          hint: "Métaphore organique d'unité",
          funFact: "👤 Corps du Christ : chaque chrétien est un membre vital - interdépendance!"
        },
        medium: {
          question: "Quelle armure Paul décrit-il pour le combat spirituel ?",
          options: [
            "Armure physique",
            "Armure de Dieu : vérité, justice, paix, foi, salut, Parole",
            "Armure romaine",
            "Protection magique"
          ],
          correct: 1,
          hint: "Six pièces d'armure spirituelle",
          funFact: "⚔️ Combat spirituel avec armes spirituelles - stratégie divine de victoire!"
        },
        hard: {
          question: "Contre qui est notre véritable combat selon Paul ?",
          options: [
            "Contre les hommes méchants",
            "Contre les puissances spirituelles de méchanceté",
            "Contre les gouvernements",
            "Contre la pauvreté"
          ],
          correct: 1,
          hint: "Il s'agit de forces spirituelles invisibles",
          funFact: "👹 Combat cosmique : derrière les conflits humains, guerre spirituelle réelle!"
        }
      }
    },

    87: {
      name: "Philippiens : La Joie dans l'Épreuve",
      challenge: "Réjouissez-vous toujours dans le Seigneur ; je le répète, réjouissez-vous !",
      questions: {
        easy: {
          question: "Quel sentiment Paul encourage-t-il malgré sa prison ?",
          options: ["La résignation", "La joie", "La colère", "La tristesse"],
          correct: 1,
          hint: "Émotion surprenante pour un prisonnier",
          funFact: "😊 Joie 16 fois en 4 chapitres - record biblique de bonheur en prison!"
        },
        medium: {
          question: "Selon Philippiens 2, quelle attitude Jésus a-t-il adoptée ?",
          options: [
            "Il s'est imposé par force",
            "Il s'est abaissé et humilié jusqu'à la mort",
            "Il a fui ses responsabilités",
            "Il a cherché la gloire"
          ],
          correct: 1,
          hint: "Mouvement descendant volontaire",
          funFact: "📉 Jésus : de l'égalité avec Dieu à la mort sur la croix - amour extrême!"
        },
        hard: {
          question: "Comment Paul peut-il prêcher la joie en prison ?",
          options: [
            "Il fait semblant",
            "La joie chrétienne transcende les circonstances",
            "Il est masochiste",
            "Il nie la réalité"
          ],
          correct: 1,
          hint: "Il s'agit d'une joie surnaturelle",
          funFact: "✨ Joie = fruit de l'Esprit indépendant des circonstances - secret divin!"
        }
      }
    },

    88: {
      name: "Les Épîtres Pastorales",
      challenge: "Combats le bon combat de la foi, saisis la vie éternelle...",
      questions: {
        easy: {
          question: "À qui Paul écrivit-il ses dernières lettres pastorales ?",
          options: [
            "Aux Corinthiens",
            "À Timothée et Tite",
            "Aux Romains",
            "Aux Galates"
          ],
          correct: 1,
          hint: "Ses fils spirituels et collaborateurs",
          funFact: "👨‍👦 Testament spirituel : Paul transmet le flambeau à la génération suivante!"
        },
        medium: {
          question: "Quel conseil Paul donne-t-il pour choisir les dirigeants d'église ?",
          options: [
            "Choisir les plus riches",
            "Choisir selon des critères moraux et spirituels stricts",
            "Choisir les plus instruits",
            "Choisir les plus populaires"
          ],
          correct: 1,
          hint: "Qualifications morales avant tout",
          funFact: "⚖️ Standards élevés pour dirigeants : caractère avant compétence - priorités divines!"
        },
        hard: {
          question: "Quel héritage Paul lègue-t-il à Timothée ?",
          options: [
            "Des biens matériels",
            "La fidélité à l'Évangile et le ministère pastoral",
            "Une fonction politique",
            "Une école théologique"
          ],
          correct: 1,
          hint: "Il s'agit d'héritage spirituel",
          funFact: "📜 'Garde le bon dépôt' - transmission fidèle de l'Évangile à travers les âges!"
        }
      }
    },

    89: {
      name: "Hébreux : Jésus Souverain Sacrificateur",
      challenge: "Nous avons un grand souverain sacrificateur qui a traversé les cieux...",
      questions: {
        easy: {
          question: "Selon Hébreux, qui est notre grand souverain sacrificateur ?",
          options: ["Aaron", "Moïse", "Jésus", "Melchisédek"],
          correct: 2,
          hint: "Le médiateur parfait entre Dieu et les hommes",
          funFact: "✝️ Jésus : Prêtre et Victime - sacrifice parfait une fois pour toutes!"
        },
        medium: {
          question: "Pourquoi le sacerdoce de Jésus est-il supérieur à celui d'Aaron ?",
          options: [
            "Il est plus ancien",
            "Il est éternel selon l'ordre de Melchisédek",
            "Il est plus riche",
            "Il est plus populaire"
          ],
          correct: 1,
          hint: "Éternité vs temporalité",
          funFact: "♾️ Sacerdoce éternel : Jésus intercède perpétuellement pour nous!"
        },
        hard: {
          question: "Comment Hébreux présente-t-il la Nouvelle Alliance ?",
          options: [
            "Identique à l'ancienne",
            "Supérieure et définitive, écrite dans les cœurs",
            "Temporaire",
            "Facultative"
          ],
          correct: 1,
          hint: "Il s'agit d'accomplissement et de dépassement",
          funFact: "📋 Nouvelle Alliance : loi écrite dans les cœurs, non sur la pierre!"
        }
      }
    },

    90: {
      name: "Jacques : La Foi et les Œuvres",
      challenge: "La foi sans les œuvres est morte...",
      questions: {
        easy: {
          question: "Selon Jacques, que doit accompagner la foi ?",
          options: [
            "Les paroles",
            "Les œuvres",
            "Les émotions",
            "Les connaissances"
          ],
          correct: 1,
          hint: "Manifestation pratique de la foi",
          funFact: "🌳 Foi = racine, œuvres = fruits - arbre spirituel complet!"
        },
        medium: {
          question: "À quoi Jacques compare-t-il la langue ?",
          options: [
            "À une épée",
            "À un petit feu qui embrase une grande forêt",
            "À un instrument de musique",
            "À un outil"
          ],
          correct: 1,
          hint: "Petit membre mais grand pouvoir destructeur",
          funFact: "🔥 Langue : petit membre mais peut incendier toute une vie - prudence!"
        },
        hard: {
          question: "Comment réconcilier Jacques et Paul sur foi/œuvres ?",
          options: [
            "Ils se contredisent",
            "Paul parle de justification, Jacques de sanctification",
            "L'un a tort",
            "Il n'y a pas de solution"
          ],
          correct: 1,
          hint: "Il s'agit de deux aspects complémentaires",
          funFact: "⚖️ Paul : sauvés par la foi / Jacques : foi prouvée par œuvres - harmonie parfaite!"
        }
      }
    },

    91: {
      name: "Apocalypse : Le Retour du Roi",
      challenge: "Voici, je viens bientôt. Heureux celui qui garde les paroles de ce livre !",
      questions: {
        easy: {
          question: "À combien d'églises Jean écrit-il dans l'Apocalypse ?",
          options: ["5", "7", "10", "12"],
          correct: 1,
          hint: "Le nombre de la perfection",
          funFact: "⛪ 7 églises d'Asie : miroir de toutes les églises de tous les temps!"
        },
        medium: {
          question: "Comment se termine l'histoire selon l'Apocalypse ?",
          options: [
            "Destruction totale",
            "Nouveaux cieux et nouvelle terre",
            "Retour au paradis terrestre",
            "Fin de toute existence"
          ],
          correct: 1,
          hint: "Renouvellement complet de la création",
          funFact: "🌅 Non pas fin du monde mais renouveau total - espérance ultime!"
        },
        hard: {
          question: "Quel message central l'Apocalypse transmet-elle aux persécutés ?",
          options: [
            "Résignez-vous",
            "Christ règne et triomphera définitivement",
            "Fuyez la persécution",
            "Vengez-vous"
          ],
          correct: 1,
          hint: "Il s'agit d'espérance dans la victoire finale",
          funFact: "👑 'Celui qui était, qui est et qui vient' - Seigneur de l'histoire et du temps!"
        }
      }
    }
  }
};